import React from 'react';
import { css } from '@emotion/css';
import _map from 'lodash/map';

import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';

import { feedbackInScaleFiveConfig } from './config';
import { emojis } from './consts';
import MoodEmoji from './MoodEmoji';
import MoodEmojiContainer from './MoodEmojiContainer';
import { MoodEmojiProps } from './types';

export const emojiContainer = css`
  /* EmojiDisplay.css */

  .emoji-container {
    display: inline-block;
    filter: grayscale(100%);
    opacity: 0.4;
    transition:
      filter 0.3s ease-in-out,
      opacity 0.3s ease-in-out;
  }

  .emoji-container:hover {
    opacity: 1;
    filter: grayscale(0);
  }

  .emoji-selected {
    filter: grayscale(0);
    opacity: 1;
  }
`;

const MoodEmojiList = (props: MoodEmojiProps) => {
  const { onClick, activeEmoji: _activeEmoji, styles } = props;

  return (
    <MoodEmojiContainer faceScaleFactor={styles?.faceScaleFactor} spacing={styles?.spacing}>
      {_map(emojis, (emoji) => (
        <MoodEmoji
          key={emoji.id}
          emojiId={emoji.id}
          hoverScaleFactor={styles?.hoverScaleFactor}
          isActive={_activeEmoji === emoji.id}
          scaleFactor={styles?.scaleFactor}
          onClick={onClick}
        />
      ))}
    </MoodEmojiContainer>
  );
};

export const RateFiveEmojiList = (props: MoodEmojiProps) => {
  const { onClick, activeEmoji, size, className } = props;

  return (
    <Stack className={cn(emojiContainer, className)} direction="row">
      {_map(feedbackInScaleFiveConfig, ({ label, id }) => (
        <Box
          key={id}
          style={{ fontSize: `${size}px` }}
          className={cn(
            'emoji-container cursor-pointer', // @ts-ignore
            activeEmoji === id ? 'emoji-selected' : '',
          )}
          // @ts-ignore
          onClick={() => onClick(id)}>
          {label}
        </Box>
      ))}
    </Stack>
  );
};

export default MoodEmojiList;
